import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cpq-responder',
  template: ``,
  styles: [],
})
export class CPQResponderComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      window.parent.postMessage(
        { type: 'CPQ_RESPONDER', data: { ...params } },
        '*'
      );
    });
  }
}
